import React from "react";
import { Box } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * A soft ring that breathes behind `children` — "you are here" on the participation ladder. Purely
 * decorative (aria-hidden); with "reduce motion" the ring is shown still. Added by the 2026-09-12 design pass.
 */
export function GovPulse({ color, size, children }: { color: string; size: number; children: React.ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <Box position="relative" w={`${size}px`} h={`${size}px`} flexShrink={0}>
      <Box aria-hidden position="absolute" inset={0} pointerEvents="none">
        {reduce ? (
          <Box w="100%" h="100%" borderRadius="full" boxShadow={`0 0 0 6px ${color}`} opacity={0.35} />
        ) : (
          <motion.div
            style={{ width: "100%", height: "100%", borderRadius: "9999px", background: color }}
            initial={{ scale: 1, opacity: 0.45 }}
            animate={{ scale: 1.55, opacity: 0 }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
          />
        )}
      </Box>
      <Box position="relative" w="100%" h="100%">{children}</Box>
    </Box>
  );
}
